<template>
  <PerfectScrollbar
    class="pr-2"
    :options="{
      suppressScrollX: true
    }"
  >
    <base-row align="center" justify="space-between" class="ma-0 pa-0 mb-1">
      <base-col cols="6" class="py-0 pl-3 ma-0 d-flex align-center">
        <slot name="actionSlotbeforeTitle"></slot>
        <p v-if="pageTitle && lgAndUp" class="text-h6">{{ pageTitle }}</p>
      </base-col>

      <base-col cols="2" class="d-flex justify-end pa-0 ma-0">
        <slot name="actionSlot"></slot>
      </base-col>
    </base-row>
    <base-row class="bg-surface ma-0 pa-0 pr-1">
      <base-col cols="12">
        <slot />
      </base-col>
    </base-row>
  </PerfectScrollbar>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { BaseRow, BaseCol } from '@deltax/vuetify-wrapper-components'
  import { useDisplay } from 'vuetify'
  import { PerfectScrollbar } from 'vue3-perfect-scrollbar'

  const route = useRoute()
  const { lgAndUp } = useDisplay()
  const pageTitle = computed(() => route.meta.title || null)
</script>
